module.exports = __webpack_public_path__ + "static/img/bus-content-4.5465d19.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bus-content-4.jpg
// module id = pvAU
// module chunks = 0